// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateTime'
})
export class DateTimePipe extends DatePipe implements PipeTransform {
  public transform(value: string): any {
    return super.transform(+value * 1000 , 'yyyy-MM-dd HH:mm O');
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/date-time.pipe.ts